import { render, staticRenderFns } from "./ChamberInfo.vue?vue&type=template&id=25251b26&scoped=true&"
import script from "./ChamberInfo.vue?vue&type=script&lang=js&"
export * from "./ChamberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25251b26",
  null
  
)

export default component.exports